import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "ion-padding-start",
  slot: "content"
}
const _hoisted_2 = {
  class: "ion-padding-start",
  slot: "content"
}
const _hoisted_3 = {
  class: "ion-padding-start",
  slot: "content"
}
const _hoisted_4 = {
  class: "ion-padding-start",
  slot: "content"
}
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!

  return (_openBlock(), _createElementBlock("div", null, [
    (['requiredElective1', 'requiredElective2', 'requiredElective3', 'preferredSubjects'].some(key => $props.item[key].length > 0))
      ? (_openBlock(), _createBlock(_component_ion_accordion_group, {
          key: 0,
          multiple: true,
          value: ['re1', 're2', 're3', 'pes'],
          readonly: ""
        }, {
          default: _withCtx(() => [
            ($props.item.requiredElective1.length > 0)
              ? (_openBlock(), _createBlock(_component_ion_accordion, {
                  key: 0,
                  value: "re1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      lines: "full",
                      slot: "header",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withCtx(() => _cache[1] || (_cache[1] = [
                            _createElementVNode("p", null, [
                              _createElementVNode("b", null, "Must take at least 1 elective from")
                            ], -1)
                          ])),
                          _: 1,
                          __: [1]
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_1, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.requiredElective1, (electiveName) => {
                        return (_openBlock(), _createBlock(_component_ion_item, { key: electiveName }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", null, _toDisplayString(electiveName), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ($props.item.requiredElective2.length > 0)
              ? (_openBlock(), _createBlock(_component_ion_accordion, {
                  key: 1,
                  value: "re2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      lines: "full",
                      slot: "header"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withCtx(() => _cache[2] || (_cache[2] = [
                            _createElementVNode("p", null, [
                              _createElementVNode("b", null, "Must take at least 1 elective from")
                            ], -1)
                          ])),
                          _: 1,
                          __: [2]
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_2, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.requiredElective2, (electiveName) => {
                        return (_openBlock(), _createBlock(_component_ion_item, { key: electiveName }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", null, _toDisplayString(electiveName), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ($props.item.requiredElective3.length > 0)
              ? (_openBlock(), _createBlock(_component_ion_accordion, {
                  key: 2,
                  value: "re3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      lines: "full",
                      slot: "header"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                            _createElementVNode("p", null, [
                              _createElementVNode("b", null, "Must take at least 1 elective from")
                            ], -1)
                          ])),
                          _: 1,
                          __: [3]
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_3, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.requiredElective3, (electiveName) => {
                        return (_openBlock(), _createBlock(_component_ion_item, { key: electiveName }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", null, _toDisplayString(electiveName), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ($props.item.preferredSubjects.length > 0)
              ? (_openBlock(), _createBlock(_component_ion_accordion, {
                  key: 3,
                  value: "pes"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      lines: "full",
                      slot: "header"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                            _createElementVNode("p", null, [
                              _createElementVNode("b", null, "Suggested/Upweighted subjects")
                            ], -1)
                          ])),
                          _: 1,
                          __: [4]
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.preferredSubjects, (electiveName) => {
                        return (_openBlock(), _createBlock(_component_ion_item, { key: electiveName }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", null, _toDisplayString(electiveName), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_ion_item, { lines: "full" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createElementVNode("p", null, [
                    _createElementVNode("b", null, "No special elective requirements")
                  ], -1)
                ])),
                _: 1,
                __: [5]
              })
            ]),
            _: 1
          })
        ]))
  ]))
}